// Static data for the Footer component
import {
  FiFacebook,
  FiInstagram,
  FiLinkedin,
  FiArrowUp,
} from 'react-icons/fi';
import {
  FaYoutube,
  FaWhatsapp,
} from 'react-icons/fa6';

export const FOOTER_BRAND = {
  name: 'OrbisDMC',
  tagline: 'Vietnam\'s Premier Destination Management Company',
  description:
    'Vietnam-based DMC crafting seamless, tailor-made journeys for partners and global travellers.',
};

export const FOOTER_QUICK_LINKS = {
  title: 'Quick Links',
  links: [
    { label: 'About Us', path: '/about' },
    { label: 'Partner With Us', path: '/partner-with-us' },
    { label: 'News & Insights', path: '/news' },
    { label: 'Careers', path: '/careers' },
    { label: 'Contact Us', path: '/contact' },
  ],
};

export const FOOTER_DESTINATIONS = {
  title: 'Destinations',
  links: [
    { label: 'Hanoi & the North', path: '/destinations/hanoi' },
    { label: 'Ha Long Bay', path: '/destinations/ha-long-bay' },
    { label: 'Da Nang & Hoi An', path: '/destinations/da-nang-hoi-an' },
    { label: 'Ho Chi Minh City', path: '/destinations/saigon' },
    { label: 'Phu Quoc Island', path: '/destinations/phu-quoc' },
    { label: 'Sapa & Mountains', path: '/destinations/sapa' },
  ],
};

export const FOOTER_SERVICES = {
  title: 'Services',
  links: [
    { label: 'Custom Itineraries', path: '/services/custom-itineraries' },
    { label: 'Group & MICE Travel', path: '/services/mice' },
    { label: 'Luxury Accommodations', path: '/services/luxury-stays' },
    { label: 'Visa & Documentation', path: '/services/visa' },
    { label: 'Private Transport', path: '/services/transport' },
  ],
};

export const FOOTER_CONTACT = {
  title: 'Get In Touch',
  address: '12 Le Duan Street, District 1,\nHo Chi Minh City, Vietnam',
  email: 'partners@indochinedmc.com',
  phone: '+84 28 3822 1190',
  phoneHref: '+842838221190',
};

export const FOOTER_SOCIALS = [
  { icon: FiFacebook, label: 'Facebook', path: '#' },
  { icon: FiInstagram, label: 'Instagram', path: '#' },
  { icon: FiLinkedin, label: 'LinkedIn', path: '#' },
  { icon: FaYoutube, label: 'YouTube', path: '#' },
];

export const LEGAL_LINKS = [
  { label: 'Privacy Policy', path: '/privacy-policy' },
  { label: 'Terms & Conditions', path: '/terms-conditions' },
  { label: 'Cookie Policy', path: '/cookie-policy' },
];

export const BACK_TO_TOP_ICON = FiArrowUp;
